import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useDirectoryUnlockRecordByIdMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useUnlockDirectoryRecord = () => {
  const [handle, { loading, error: apolloError }] =
    useDirectoryUnlockRecordByIdMutation();

  const error = useError(apolloError);

  return {
    loading,
    error,
    unlock: useCallback(
      async (id: string) => {
        await handle({ variables: { id } });
      },
      [handle]
    ),
  };
};
